<div class="toast" [ngClass]="data.type">
    <div class="toast-cotent">{{data.message}}</div>
    <button class="small-icon" mat-icon-button mat-dialog-close>
        <mat-icon close >close</mat-icon>
    </button>
</div>